import React from 'react';
import PropTypes from 'prop-types';

// import envelopes from '../../../assets/images/doodles/guestlist/envelopes.svg';
import nameCardWithQuestionMarks from '../../../assets/images/doodles/namecard_with_question_marks.svg';

function NoGuests({ onAddGuestGroup, onEnableGuestListOnboarding }) {
  return (
    <div id="guestlist-empty-state">
      <div className="container">
        <div className="no-guests-content">
          <img src={nameCardWithQuestionMarks} alt="one envelopes" />
          <h3>Your Guest List is Empty!</h3>
          <button className="btn btn-primary btn-wide" onClick={() => onAddGuestGroup('SINGLE')}>+ Add Guests</button>
          <div className="cta-group">
            <span className="cta-copy">PS: This info lets us work our guest addressing magic later.</span>
            <a onClick={onEnableGuestListOnboarding} className="text-button cta-action">Get Started &rsaquo;</a>
          </div>
        </div>
      </div>
    </div>
  );
}

NoGuests.propTypes = {
  onAddGuestGroup: PropTypes.func.isRequired,
  onEnableGuestListOnboarding: PropTypes.func.isRequired,
};

export default NoGuests;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/NoGuests.jsx